<div *ngIf="report">
  <div
    *ngIf="generateReportErrorMessage"
    class="alert alert-danger"
    role="alert"
  >
    {{ generateReportErrorMessage }}
  </div>

  <app-address
    [reportId]="report.id"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    [addressInput]="report.addressInput.trim()"
    [addressAccuracyLevel]="report.addressAccuracyLevel"
    [propertyType]="report.propertyType"
    [districtName]="report.districtName"
    [addressCity]="report.addressCity"
    [addressType]="report.geo.addressType"
    (addressSaved)="onAddressSaved($event)"
  >
  </app-address>


  <div class="d-flex align-items-center border-primary justify-content-between">
    <div class="formulaire-parametrage-title">Paramétrage du rapport</div>
    <div class="formulaire-parametrage-infos">
      N'oubliez pas de consulter les
      <a
        class="text-decoration-underline pointer link-protection-donnees "
        (click)="openDataProtectionModal()"
        >règles sur la protection des données</a
      >.
    </div>
  </div>

  <app-expert-immobilier
    [expert]="report.sections.expert"
    [reportId]="report.id"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (expertChanged)="onExpertChanged($event)"
    (expertEnabled)="onExpertEnabled($event)"
    (cancled)="onCancled()"
    [roles]="roles"
  >
  </app-expert-immobilier>

  <app-notre-organisme
    [organisme]="report.sections.organisme"
    [reportId]="report.id"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (organismeChanged)="onOrganismeChanged($event)"
    (organismeEnabled)="onOrganismeEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-notre-organisme>

  <div class="text-secondary text-uppercase fw-bold fs-5">
    Présentation de la mission
  </div>

  <app-informations-client
    [informationsClient]="report.sections.customer"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (informationsClientChanged)="onInformationsClientChanged($event)"
    (informationsClientEnabled)="onInformationsClientEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-informations-client>

  <app-details-dossier
    [detailsDossier]="report.sections.case"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (detailsDossierChanged)="onDetailsDossierChanged($event)"
    (detailsDossierEnabled)="onDetailsDossierEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-details-dossier>

  <div class="text-secondary text-uppercase fw-bold fs-5">
    Présentation du bien
  </div>

  <app-informations-bien
    [informationsBien]="report.sections.property"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (informationsBienChanged)="onInformationsBienChanged($event)"
    (informationsBienEnabled)="onInformationsBienEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-informations-bien>

  <app-caracteristiques
    [characteristics]="report.sections.characteristics"
    [propertyType]="report.propertyType"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (characteristicsChanged)="onCharacteristicsChanged($event)"
    (characteristicsEnabled)="onCharacteristicsEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-caracteristiques>

  <app-les-plus
    [perks]="report.sections.perks"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (perksChanged)="onPerksChanged($event)"
    (perksEnabled)="onPerksEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-les-plus>
  <app-les-moins
    [drawbacks]="report.sections.drawbacks"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (drawbacksChanged)="onDrawbacksChanged($event)"
    (drawbacksEnabled)="onDrawbacksEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-les-moins>
  <app-photographies
    [photographies]="report.sections.photographs"
    [reportId]="report.id"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (photographiesChanged)="onPhotographiesChanged($event)"
    (photographiesEnabled)="onPhotographiesEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-photographies>

  <app-biens-comparables-vendus
    [references]="report.sections.references"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    [reportType]="report.type"
    (referencesChanged)="onReferencesChanged($event)"
    (referencesEnabled)="onReferencesEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-biens-comparables-vendus>

  <app-tendance-marche-immobilier
    *ngIf="(report.propertyType.code === 'APP' || report.propertyType.code === 'MAI') && report?.sections?.tendencies as tendencies"
    [tendencies]="tendencies"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (tendenciesEnabled)="onTendenciesEnabled($event)"
    (tendenciesChanged)="onTendenciesChanged($event)"
    class="mb-5"
  >
  </app-tendance-marche-immobilier>

  <app-statistiques
    *ngIf="!report?.sections?.tendencies && report.sections.statistics as statistics"
    [statistics]="statistics"
    (statisticsEnabled)="onStatisticsEnabled($event)"
    class="mb-5"
  >
  </app-statistiques>

  <app-cartographie [report]="report"> </app-cartographie>

  <app-cadastre
    *ngIf="report.propertyType.code != 'APP'"
    [reportId]="report.id"
    [cadastre]="report.sections.cadastre"
    [cityLabel]="report.addressCity"
    [cityCode]="report.addressCityCode"
    [propertyType]="report.propertyType"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (cadastreEnabled)="onCadastreEnabled($event)"
    (cadastreChanged)="onCadastreChanged($event)"
    (cancled)="onCancled()"
  ></app-cadastre>

  <app-votre-estimation
    [appraisal]="report.sections.appraisal"
    [historyLegacyId]="report.historyLegacyId"
    [reportType]="report.type"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (appraisalChanged)="onAppraisalChanged($event)"
    (appraisalEnabled)="onAppraisalEnabled($event)"
    (cancled)="onCancled()"
  ></app-votre-estimation>

  <app-notes
    [notes]="report.sections.notes"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (notesChanged)="onNotesSaved($event)"
    (notesEnabled)="onNotesEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-notes>

  <app-definitions
    [definitions]="report.sections.definitions"
    [isLoading]="isLoadingGenerateReport || isLoadingResetReport"
    (definitionsChanged)="onDefinitionsSaved($event)"
    (definitionsEnabled)="onDefinitionsEnabled($event)"
    (cancled)="onCancled()"
  >
  </app-definitions>

  <div class="d-flex justify-content-end gap-2">
    <p-button
      id="btn-reset-report"
      label="Réinitialiser"
      level="secondary"
      [loading]="isLoadingResetReport"
      [disabled]="isLoadingResetReport || isLoadingGenerateReport"
      [width]="100"
      (click)="resetReport()"
    ></p-button>

    <p-button
      id="btn-generate-report"
      label="Générer le rapport"
      level="primary"
      [loading]="isLoadingGenerateReport"
      [disabled]="isLoadingGenerateReport || isLoadingResetReport"
      [width]="100"
      (click)="generateReport()"
    ></p-button>
  </div>
</div>

<p-modal
  *ngIf="isResetReportModalOpen"
  [modalId]="modalId.RESET_REPORT_MODAL"
  title="Réinitialiser le rapport"
  (confirm)="onResetReportModalConfirm()"
  (cancel)="onResetReportModalCancel()"
>
  <p>
    Toutes vos modifications seront perdues. Souhaitez-vous vraiment
    réinitialiser le formulaire ?
  </p>

  <div class="d-flex justify-content-end gap-2">
    <p-button
      label="Annuler"
      level="secondary"
      (click)="onResetReportModalCancel()"
    ></p-button>
    <p-button
      label="Valider"
      level="primary"
      (click)="onResetReportModalConfirm()"
    ></p-button>
  </div>
</p-modal>

<p-modal
  *ngIf="isDataProtectionModalOpen"
  [modalId]="modalId.DATA_PROTECTION_MODAL"
  title="RAPPEL DES RÈGLES DE PROTECTION DES DONNÉES PERSONNELLES"
  (cancel)="onDataProtectionModalClose()"
>
  <p class="d-flex align-items-center border-primary justify-content-center">
    ZONES DE COMMENTAIRES LIBRES
  </p>
  <p class="d-flex align-items-center border-primary justify-content-center">
    J'ADOPTE LES BONNES PRATIQUES
  </p>
  <p class="d-flex align-items-center border-primary justify-content-center">
    UTILISEZ LES COMMENTAIRES AVEC LA PLUS GRANDE PRUDENCE ! POURQUOI ?
  </p>
  <p>
    JE COLLECTE ET ENREGISTRE LES SEULES INFORMATIONS PERTINENTES<br>
    Les commentaires doivent être appropriés à l'objectif poursuivi. Ils ne doivent pas faire mention
    de jugements subjectifs et/ou peu élogieux : traits de caractère des interlocuteurs, injures etc<br>
    Les champs d'annotation contenant des informations excessives ou discriminatoires ont déjà fait l'objet de nombreuses
    sanctions par la CNIL.
  </p>
  <p>
    JE RESTE VIGILANT CONCERNANT LES INFORMATIONS "SENSIBLES"<br>
    Enfin, ces informations sont souvent accessibles par l'ensemble des collaborateurs y compris ceux n'étant pas en lien
    direct avec le dossier. Il conviendra d'éviter absolument la rédaction de commentaires faisant apparaitre des informations
    relatives :
  </p>
  <ul>
    <li> à la santé : physique ou mentale, pathologie,</li>
    <li>aux origines raciales ou ethniques,</li>
    <li>à la vie ou à l'orientation sexuelle,</li>
    <li>aux convictions religieuses ou philosophiques,</li>
    <li>aux condamnations,</li>
    <li>aux opinions politiques,</li>
    <li>à l'appartenance syndicale.</li>
  </ul>
  <br>
  <p>
    A défaut, ou en cas de doute, mieux vaut s'abstenir d'en formuler.
  </p>
  <p>
    JE GARDE A L'ESPRIT LES DROITS DES PERSONNES<br>
    Toute personne peut, dès qu'elle le souhaite, demander communication des informations la concernant.
  </p>


  <div class="d-flex justify-content-end gap-2">
    <p-button
      label="J'ai compris"
      level="primary"
      (click)="onDataProtectionModalClose()"
    ></p-button>
  </div>
</p-modal>
